import React, {Component} from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import cn from 'classnames'
import {Form, Field} from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'

import {ReactComponent as DropdownIcon} from '../assets/images/icons/dropdown.svg'
import ScrollAnimation from './ScrollAnimation'
import InputField from './InputField'
import PACKS from '../fixtures/packs'
import './ContactForm.scss'

export const regExps = {
  // eslint-disable-next-line
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // eslint-disable-next-line
  url: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i,
}

const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

const inpurLabelProps = {
  shrink: true,
}

export const validate = values => {
  const errors = {}
  if (!values.name) errors.name = 'enter name'
  if (!values.email || !regExps.email.test(values.email)) errors.email = 'email incorrect'
  if (values.website && !regExps.url.test(values.website)) errors.website = 'url incorrect'
  return errors
}

const initialValues = {
  isPack: true,
}

export default class ContactForm extends Component {
  state = {
    anchorEl: null,
    isFetch: false,
    isSuccess: false,
    isError: false,
    errorMessage: null,
    selected: this.props.selectedPack,
  }

  static propTypes = {
    selectedPack: PropTypes.string.isRequired,
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.selectedPack !== this.props.selectedPack) this.setState({selected: nextProps.selectedPack})
  }

  handleFormSubmit = ({isPack, isBrandRefresh, isSupport, isMarketing, ...values}, form) => {
    const {selected} = this.state
    this.setState({isFetch: true})
    const data = {
      ...values,
      pack: isPack ? selected : 'Help me to choose',
    }
    if (isMarketing) {
      data.marketing = true
    }
    if (isBrandRefresh) {
      data.branding = true
    }
    if (isSupport) {
      data.support = true
    }
    axios
      .post('https://api.7glyphs.com/api/mail/brief/lite', data)
      .then(() => {
        this.setState({isFetch: false, isSuccess: true})
        form.reset()
      })
      .catch(error =>
        this.setState({
          isFetch: false,
          isError: true,
          errorMessage:
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong',
        })
      )
  }

  handleSuccessClose = () => this.setState({isSuccess: false})

  handleErrorClose = () => this.setState({isError: false})

  handleOpen = e => this.setState({anchorEl: e.currentTarget})

  handleClose = () => this.setState({anchorEl: null})

  handleSelectedChange = selected => () => {
    this.setState({selected}, this.handleClose)
  }

  get packs() {
    const {selected} = this.state
    return PACKS.map(({id, title}) => (
      <MenuItem key={id} onClick={this.handleSelectedChange(title)}>
        {selected === title ? <strong>{title}</strong> : title}
      </MenuItem>
    ))
  }

  renderForm = ({values, handleSubmit}) => {
    const {selected, anchorEl, isFetch} = this.state
    const packLabel = `‘${selected}’ Pack`
    const isOpen = Boolean(anchorEl)
    return (
      <form noValidate className="ContactForm" autoComplete="off" onSubmit={handleSubmit}>
        <ScrollAnimation effect="fadeInBottomSmall">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <div className="ContactForm-Block">
                <Field id="name" name="name" label="Name *" component={InputField} />
                <Field name="company" label="Company Name" component={InputField} />
                <Field name="phone" label="Phone Number" component={InputField} />
                <Field name="email" type="email" label="Email *" component={InputField} />
                <Field name="website" type="url" label="Website" component={InputField} />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className="ContactForm-SubmitBlock">
                <div>
                  <p className="ContactForm-Label">Interested services</p>
                  <div className="ContactForm-Selections">
                    <div className="ContactForm-SelectionsBlock">
                      <div className="ContactForm-DropdownBlock">
                        <Field
                          name="isPack"
                          type="checkbox"
                          label={values.isPack ? null : packLabel}
                          component={InputField}
                        />
                        {values.isPack && (
                          <>
                            <button
                              className={cn('ContactForm-DropdownButton', {
                                'ContactForm-DropdownButton_open': isOpen,
                              })}
                              type="button"
                              onClick={this.handleOpen}
                            >
                              <span className="ContactForm-DropdownLabel">{packLabel}</span>
                              {values.isPack && <DropdownIcon className="ContactForm-DropdownIcon" />}
                            </button>
                            <Menu keepMounted anchorEl={anchorEl} open={isOpen} onClose={this.handleClose}>
                              {this.packs}
                            </Menu>
                          </>
                        )}
                      </div>
                      <Field name="isBrandRefresh" type="checkbox" label="Brand Refresh" component={InputField} />
                    </div>
                    <div className="ContactForm-SelectionsBlock">
                      <Field name="isSupport" type="checkbox" label="Support" component={InputField} />
                      <Field name="isMarketing" type="checkbox" label="Marketing" component={InputField} />
                    </div>
                  </div>
                  <Field
                    multiline
                    name="message"
                    rowsMax={8}
                    label="Message"
                    placeholder="Write text here..."
                    InputLabelProps={inpurLabelProps}
                    component={InputField}
                  />
                </div>
                <div className="ContactForm-Submit">
                  <Button fullWidth type="submit" variant="contained" color="primary" disabled={isFetch}>
                    <span className="ContactForm-SubmitText">Send message</span>
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </ScrollAnimation>
      </form>
    )
  }

  render() {
    const {isSuccess, isError, errorMessage} = this.state
    return (
      <>
        <Form
          initialValues={initialValues}
          validate={validate}
          onSubmit={this.handleFormSubmit}
          render={this.renderForm}
        />
        <Snackbar
          open={isSuccess}
          anchorOrigin={anchorOrigin}
          autoHideDuration={6000}
          message="Your message has been successfully sent"
          onClose={this.handleSuccessClose}
        />
        <Snackbar
          open={isError}
          anchorOrigin={anchorOrigin}
          autoHideDuration={6000}
          message={errorMessage}
          onClose={this.handleErrorClose}
        />
      </>
    )
  }
}
